import React, { Component } from 'react';
import { Spinner } from "react-bootstrap";
import { connect} from "remx";
import axios from "axios";
import moment from 'moment-with-locales-es6';
import InfiniteScroll from 'react-infinite-scroll-component';
import broker from '../../../utils/broker';
import config from '../../../utils/config';
import dataStore from '../../../stores/data';
import ChartPelanggan from './ChartPelanggan_';
import SidebarTree from '../SidebarTree';

const CancelToken = axios.CancelToken;
let cancel;
let cancelFetch;
class Laporan extends Component {
    constructor(props) {
        super(props);
    
    this.options = {

    }

    this.state = {
            reload:false,
            loading: false,
            id_pk_column: 'id',
            detail_kategori : {},
            data_pelanggan : [],
            save : 'Save',
            status_save : false,
            url_report: '',
            show_graphic : false,
            data_meta: {current_page: 0, from : 0, last_page: 0, per_page: 0, total: 0, to : 0},
            page_index:1,
            items: Array.from({ length: 50 }) // infinite

        }
    }

    prevNextDay(count){
        var type_view = this.props.type_view;
        var date = this.props.date_view;
        if (type_view === 'month'){
            date = moment(date).add(count, 'month');
        } else {
            date = moment(date).add(count, 'days');
        }
        dataStore.setters.setDataDateView(moment(date).locale('id').format('YYYY-MM-DD'));
        dataStore.setters.setDataMonthView(parseInt(moment(date).locale('id').format('MM'))-1);
        this.setState({prev_next : (count === (+1)) ? 'next' : 'prev'});
    }

    setDataType(type) {
        dataStore.setters.setDataTypeView(type);
    }

    setNow(){
        dataStore.setters.setDataDateView(moment().locale('id').format('YYYY-MM-DD'));
        dataStore.setters.setDataTypeView('day');
        dataStore.setters.setDataMonthView(parseInt(moment().locale('id').format('MM'))-1);
        this.setState({prev_next : ''});
    }

    componentWillUnmount(){
        if (cancel !== undefined) {
            cancel();
        }
        if (cancelFetch !== undefined) {
            cancelFetch();
        }
    }
    
    componentDidMount(){
        var addScript = document.createElement('script');
        addScript.setAttribute('src', '/assets/js/dashforge.filemgr_.js');
        document.body.appendChild(addScript);

        if (this.props.data_kategori_per.id_kategori) {
            this.getDataPelanggan();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.type_view !== prevProps.type_view ||
            this.props.month_view !== prevProps.month_view ||
            this.props.date_view !== prevProps.date_view ||
            this.props.pelanggan_id !== prevProps.pelanggan_id ||
            this.props.data_kategori_per !== prevProps.data_kategori_per) {

            if (cancelFetch !== undefined)
                cancelFetch();
        
            if (cancel !== undefined)
                cancel();

            this.setState({show_graphic: false, save: 'Save', status_save : false});
            this.setState({page_index : 1}, function(){
                this.getDataKategoriPer();
                this.getDataPelanggan();
            });

        }

        if (this.props.data_export !== prevProps.data_export) {
            // console.log(this.props.data_export.length)
            if (this.state.data_meta.total === this.props.data_export.length) {
                this.setState({status_save: true}) ;           
            }    
        }

    }

    getDataPelanggan(){
        var year = moment(this.props.date_view).locale('id').format('Y');
        this.setState({loading : true})
        broker.fetch.get(`data/kategori/${this.props.data_kategori_per.id_kategori}/pelanggan_month?page=1&month=${parseInt(this.props.month_view)+1}&year=${year}&klasifikasi_id=${this.props.data_klasifikasi.klasifikasi_id}`,
        {
            cancelToken: new CancelToken(function executor(c) {
                cancel = c;
            })
        })
        .then(res => {
            const { data } = res.data;
            if (data) {
                this.setState({
                    data_pelanggan: data.data,
                    page_index : 1,
                    data_meta: {
                        current_page: data.current_page,
                        from : data.from,
                        to : data.to,
                        last_page : data.last_page,
                        per_page : data.per_page,
                        total : data.total,
                    },
                    loading: false
                });
            } else {

            }
        }).catch(err => {
            
        });
    }

    fetchDataPelanggan(){
        var year = moment(this.props.date_view).locale('id').format('Y');
        broker.fetch.get(`data/kategori/${this.props.data_kategori_per.id_kategori}/pelanggan_month?page=${this.state.page_index}&month=${parseInt(this.props.month_view)+1}&year=${year}&klasifikasi_id=${this.props.data_klasifikasi.klasifikasi_id}`,
        {
            cancelToken: new CancelToken(function executor(c) {
                cancelFetch = c;
            })
        })
        .then(res => {
            const { data } = res.data;
            if (data) {
                // this.setState({data_pelanggan : data.data})
                this.setState({
                    data_pelanggan: this.state.data_pelanggan.concat(data.data),
                    data_meta: {
                        current_page: data.current_page,
                        from : data.from,
                        to : data.to,
                        last_page : data.last_page,
                        per_page : data.per_page,
                        total : data.total,
                    },
                    loading : false
                });
            } else {

            }
        }).catch(err => {
            
        });
    }

    getDataKategoriPer(){
        broker.fetch.get(`data/kategori/${this.props.data_kategori_per.id_kategori}`)
        .then(res => {
            const { data } = res.data;
            if (data) {
                this.setState({detail_kategori : data})
            } else {

            }
        }).catch(err => {
            
        });
    }

    toggleShow(){
        if (this.state.data_pelanggan.length > 0){
            this.setState({ show_graphic : !this.state.show_graphic, url_report: ''});
            // this.getDataPelanggan();
            dataStore.setters.setDataExport([]);
        }
            
    }

    generateContent(){
        var content = this.state.detail_kategori;
        let return_content = [];
        if (content) {
            for (var key in content){
                if(!key.includes('id') && !key.includes('created_at') && !key.includes('updated_at'))
                    return_content.push(<React.Fragment key={key}>
                                            <label className="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase" key={key}>{key.replace("_", " ")}</label>
                                            <p className="tx-13 mg-b-10">{content[key]}</p>
                                        </React.Fragment>);
    
            }
        }

        return return_content;
    }

    fetchMoreData = () => {
        if (this.state.data_pelanggan.length > 0) {
        // if (this.state.data_meta.last_page > this.state.page_index){
            this.setState({ loading : true});
            setTimeout(() => {
                var page = this.state.page_index + 1
                this.setState({page_index: page}, function(){
                    this.fetchDataPelanggan();
                })
            }, 300);
        }
    };

    downloadFile(){
        if (this.state.url_report === ''){
            this.generateReport();
        } else {
            window.open(config.api_support+'/download_report/'+this.state.url_report, "_blank")
        }
    }
    
    generateReport(){
        this.setState({loading: true, save : 'Please wait...'})
        var data_pelanggan = [];
        this.props.data_export.map((data, i) => {
            var object = {
                pelanggan_id: data.pelanggan_id, 
                nama_pelanggan : data.nama_pelanggan,
                no_urut_pelanggan: data.no_urut_pelanggan,
                klasifikasi : data.klasifikasi,
                sub_klasifikasi : data.sub_klasifikasi,
                url : data.image_url, 
                rate : data.rate,
            }; 
            data_pelanggan.push(object);
        });

        var sort_pelanggan = data_pelanggan.sort(function(a,b){
            // var a1 = a.no_urut_pelanggan;
            // var b1 = b.no_urut_pelanggan;
            // var len = Math.max(a1.length, b1.length);
            
            // for(var i = 0; i< len; i++){
            //   var _a = +a1[i] || 0;
            //   var _b = +b1[i] || 0;
            //   if(_a === _b) continue;
            //   else return _a > _b ? 1 : -1
            // }
            // return 0;
            return parseInt(a.no_urut_pelanggan) - parseInt(b.no_urut_pelanggan);
        })
        var body = {
                        url_string : config.get_api_export,
                        data_pelanggan : sort_pelanggan, 
                        kategori_id: this.props.data_kategori_per.id_kategori,
                        year : moment(this.props.date_view).locale('id').format('Y'), 
                        month: (moment(this.props.date_view).locale('id').format('M')) - 1
                    };
        broker.fetchSupport.post(`generate_report`, body)
        .then(res => {
            const { data } = res;
            if (data) {
                this.setState({url_report : data, loading: false, save: 'Download'})
            } else {

            }
        }).catch(err => {
            
        });
    }

    dynamicSort(property) {
        var sortOrder = 1;
    
        if(property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
    
        return function (a,b) {
            if(sortOrder === -1){
                return b[property].localeCompare(a[property]);
            }else{
                return a[property].localeCompare(b[property]);
            }        
        }
    }

    render(){
        return(
            <div className="contact-wrapper">
                <SidebarTree />
                <div className="contact-content" style={{left: '240px'}}>
                    <div className="chat-content-header" style={{marginTop: '-5px'}}>
                        <div>
                            <div className="btn-group" role="group" aria-label="Basic example">
                                <button className={"btn btn-sm btn-white"+(this.state.prev_next === 'prev' ? ' active' : '')} 
                                        onClick={()=> this.prevNextDay(-1)}
                                        disabled={this.state.loading ? true : false}>
                                        <i className="fa fa-angle-left"></i>
                                </button>
                                <button className={"btn btn-sm btn-white"+(this.state.prev_next === 'next' ? ' active' : '')} 
                                        onClick={()=> this.prevNextDay(+1)}
                                        disabled={this.state.loading ? true : false}>
                                        <i className="fa fa-angle-right"></i>
                                </button>
                            </div>
                            <button onClick={()=> this.setNow()} 
                                    className="btn btn-sm btn-white mg-l-10 text-black-50"
                                    disabled={moment(this.props.date_view).locale('id').format('DD MMMM YYYY') === 
                                    moment().locale('id').format('DD MMMM YYYY') || this.state.loading ? true : false}>
                                    Today
                            </button>
                        </div>
                        <div>
                            <h4 className="mg-b-0 tx-spacing-1 mg-l-90">{(this.props.type_view === 'month') ? 
                                                                moment(this.props.date_view).locale('id').format('MMMM YYYY') : 
                                                                moment(this.props.date_view).locale('id').format('DD MMMM YYYY')}
                            </h4>
                        </div>
                        <div className="d-none d-md-block  mg-r-300">
                            <div className="btn-group mg-r-10" role="group" aria-label="Basic example">
                                <button className={"btn btn-sm btn-white"+(this.props.type_view === 'month' ? ' active' : '')}  
                                        onClick={() => this.setDataType('month')}
                                        disabled={this.state.loading ? true : false}>
                                        Monthly
                                </button>
                                <button className={"btn btn-sm btn-white"+(this.props.type_view === 'day' ? ' active' : '')} 
                                        onClick={() => this.setDataType('day')}
                                        disabled={this.state.loading ? true : false}>
                                        Daily
                                </button>
                            </div>
                            <button onClick={()=> this.toggleShow()} 
                                className={"btn btn-sm btn-white mg-r-10"} 
                                disabled={(this.state.show_graphic || this.state.loading ? true : false)}>
                                    {(this.state.loading) &&
                                        <React.Fragment>
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                className="mr-2"
                                            />
                                        </React.Fragment>
                                    }
                                    Show Graphic
                            </button>
                            <button onClick={()=> this.downloadFile()} 
                                    className={"btn btn-sm " + (this.state.status_save ? "btn-danger" : "btn-white")} 
                                    disabled={this.state.status_save === false  || this.state.save === 'Please wait...' ? true : false}>
                                        {this.state.save}
                            </button>
                        </div>
                        
                    </div>
                    <div className="contact-content-body" id="contact-content-body" style={{backgroundColor: 'white', overflow: 'auto'}}>
                        <React.Fragment>
                            <div className="container">
                                <InfiniteScroll
                                    dataLength={this.state.data_pelanggan.length}
                                    next={this.fetchMoreData}
                                    hasMore={true}
                                    // loader={<h4>Please wait...</h4>}
                                    scrollableTarget="contact-content-body"
                                >
                                    {(this.state.data_pelanggan && this.state.show_graphic === true) &&
                                        this.state.data_pelanggan.map((data, i) => {
                                            return <ChartPelanggan
                                                            key={i} 
                                                            pelanggan_id={data.id}
                                                            no_urut_pelanggan={data.no_urut_pelanggan}
                                                            klasifikasi={(data.klasifikasi) ? data.klasifikasi : ''} 
                                                            sub_klasifikasi={(data.sub_klasifikasi) ? data.sub_klasifikasi : ''}
                                                            show_graphic={this.state.show_graphic} 
                                                    />
                                        })
                                    }
                                </InfiniteScroll>
                            </div>
                        </React.Fragment> 
                    </div>
                    <div className="contact-content-sidebar">
                        <label className="nav-label tx-color-03">Detail Data</label>
                        <hr className="mg-t-0"></hr>
                        {(this.state.detail_kategori) &&
                            this.generateContent()
                        }
                       
                    </div>
                </div>
            </div>
        );
    }

}

function mapStateToProps(props) {
    return {
        pelanggan_id : dataStore.getters.getDataPelangganId(),
        type_view : dataStore.getters.getDataTypeView(),
        year_view : dataStore.getters.getDataYearView(),
        month_view : dataStore.getters.getDataMonthView(),
        date_view : dataStore.getters.getDataDateView(),
        form_view : dataStore.getters.getDataFormView(),
        lat_lng : dataStore.getters.getLatLon(),
        data_pelanggan : dataStore.getters.getDataPelanggan(),
        data_kategori : dataStore.getters.getDataKategori(),
        data_kategori_per : dataStore.getters.getDataKategoriPer(),
        data_export : dataStore.getters.getDataExport(),
        data_klasifikasi: dataStore.getters.getDataKlasifikasi(),
        reload_table : dataStore.getters.getReloadTable(),
    }
}


export default connect(mapStateToProps)(Laporan);